import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=6ec0db4a&scoped=true&"
import script from "./error-404.vue?vue&type=script&lang=ts&"
export * from "./error-404.vue?vue&type=script&lang=ts&"
import style0 from "./error-404.vue?vue&type=style&index=0&id=6ec0db4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0db4a",
  null
  
)

export default component.exports